var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._m(0)])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('descricao'),
      "maxlength": "50",
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.descricao.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.descricao, "$model", $$v);
      },
      expression: "$v.form.descricao.$model"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "status",
      "label-for": "status",
      "label": "Ativo"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.status == true
    },
    on: {
      "change": _vm.setAtivo
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cliente",
      "label-for": "cliente",
      "label": "Cliente"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "placeholder": "Informe o nome do cliente",
      "label": "id_pessoa",
      "filterable": false,
      "options": _vm.clientes
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CNPJ/CPF: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.valueCliente,
      callback: function callback($$v) {
        _vm.valueCliente = $$v;
      },
      expression: "valueCliente"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.identificadores.length > 0 ? _c('b-row', _vm._l(_vm.identificadores, function (identificador) {
    return _c('b-col', {
      key: identificador.id_identificador,
      attrs: {
        "sm": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": identificador.descricao,
        "label-for": identificador.descricao
      }
    }, [_c('b-form-input', {
      attrs: {
        "maxLength": "30",
        "placeholder": _vm.placeholderIdentificador(identificador),
        "value": _vm.identificadoresFilled[identificador.descricao]
      },
      on: {
        "input": function input(value) {
          return _vm.changeValues(identificador.descricao, value);
        }
      }
    })], 1)], 1);
  }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_novo_objeto",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'objetosLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Cadastro ")])]);
}];
export { render, staticRenderFns };